import { createSurveyStyles } from '@sm/webassets';

const useStyles = createSurveyStyles(theme => {
  return {
    gridRow: {
      maxWidth: '100%',
      marginBottom: '40px',
      [`@media (min-width: ${theme.breakpoints?.sm.min})`]: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
      },
    },
    gridItem: {
      boxSizing: 'border-box',
      marginBottom: '30px',

      // applies to all maxQuestionsPerRow - just show 1 per row for small screens
      [`@media (max-width: ${theme.breakpoints?.xs.max})`]: {
        paddingRight: `0 !important`,
        width: '100% !important',
      },
    },

    // Each row configuration has its own static class to work around a
    // JSS / media - query bug when combining variable props and media-queries
    // see RAWR-735

    gridItem1Item: {
      width: '100%',
    },
    gridItem2Items: {
      [`@media (min-width: ${theme.breakpoints?.sm.min})`]: {
        paddingRight: '20px',
        width: '50%',
      },
    },
    gridItem3Items: {
      [`@media (min-width: ${theme.breakpoints?.sm.min}) and (max-width: ${theme.breakpoints?.md.max})`]: {
        paddingRight: '20px',
        // two columns layout
        width: '50%',
      },
      [`@media (min-width: ${theme.breakpoints?.lg.min})`]: {
        paddingRight: '20px',
        width: '33.33%',
      },
    },
    gridItem4Items: {
      [`@media (min-width: ${theme.breakpoints?.sm.min}) and (max-width: ${theme.breakpoints?.md.max})`]: {
        paddingRight: '20px',
        // two columns layout
        width: '50%',
      },
      [`@media (min-width: ${theme.breakpoints?.lg.min})`]: {
        paddingRight: '20px',
        width: '25%',
      },
    },
  };
});

export default useStyles;
